import { Component, OnInit } from '@angular/core';
import { SysApiService } from 'src/app/core/services/sysapi.service';

@Component({
  selector: 'app-layoutpassport',
  templateUrl: './layoutpassport.component.html',
  styleUrls: ['./layoutpassport.component.css']
})
export class LayoutpassportComponent implements OnInit {


  constructor(public sysapi:SysApiService) { }

  ngOnInit(): void {
  }

}
